import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
  constructor(private _router: Router, private _authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this._authService.getIsAuthorized().pipe(
      map((isAuthorized) => {
        if (isAuthorized) {
          return true;
        } else {
          this._router.navigate(['/']);
          return false;
        }
      }),
      catchError((err) => {
        this._router.navigate(['/']);
        return of(false);
      })
    );
  }
}
